/**
 * FAQ content used by the /faqs accordion and by the site-wide
 * search index so questions are findable from the header search.
 */
export const faqData = [
  {
    category: "Admissions",
    questions: [
      {
        question: "When are your intakes?",
        answer:
          "Zetech University admits students during three intakes every year: January, May and September."
      },
      {
        question: "How can I apply online?",
        answer:
          "Applications can be completed online through the Sajili Portal by filling in the application form, uploading the required documents and submitting your application. Successful applicants receive admission updates via email."
      },
      {
        question: "Which courses do you offer?",
        answer:
          "We offer Certificate, Diploma, Degree and Postgraduate programmes across Business, ICT, Engineering, Health Sciences, Media, Education, Hospitality, Law and many other disciplines."
      }
    ]
  },

  {
    category: "Fees & Finance",
    questions: [
      {
        question: "Do you accept fee payment in installments?",
        answer:
          "Yes. Students may pay fees using the University's 40-40-20 payment plan where 40% is paid before classes, another 40% during the second month and the remaining 20% before the fifth day of the third month."
      },
      {
        question: "Can I check my fee balance?",
        answer:
          "Yes. Students can access their fee balances, statements and payment history through the Student Portal."
      }
    ]
  },

  {
    category: "Accommodation",
    questions: [
      {
        question: "Do you have hostels?",
        answer:
          "Yes. Zetech University provides comfortable student hostels and also partners with reputable private accommodation providers near our campuses."
      },
      {
        question: "How do I apply for accommodation?",
        answer:
          "Accommodation applications are submitted through the Admissions and Student Affairs Offices after receiving admission."
      }
    ]
  },

  {
    category: "Learning",
    questions: [
      {
        question: "What study modes are available?",
        answer:
          "Students may study through Full-time, Blended Learning or Online Learning depending on the programme."
      },
      {
        question: "What is blended learning?",
        answer:
          "Blended learning combines face-to-face classroom teaching with online learning, assignments, discussions and digital resources."
      },
      {
        question: "How do students receive notes?",
        answer:
          "Students access lecture notes, assignments, discussions, quizzes and online classes through the University's Learning Management System (LMS)."
      },
      {
        question: "Who can help me with online learning?",
        answer:
          "Students experiencing challenges with online learning can contact the Digital Learning Team through elearning@zetech.ac.ke or call 0714 588863."
      }
    ]
  },

  {
    category: "General",
    questions: [
      {
        question: "Is Zetech University private or public?",
        answer:
          "Zetech University is a fully Chartered Private University in Kenya accredited by the Commission for University Education (CUE)."
      },
      {
        question: "Where are your campuses located?",
        answer:
          "The University has Technology Park Mang'u Campus, Ruiru Campus and the Zetech Digital School for online and blended learning."
      },
      {
        question: "Do you offer scholarships?",
        answer:
          "Yes. Sports scholarships are available for talented students participating in Football, Basketball, Rugby, Volleyball and other sporting disciplines."
      },
      {
        question: "Do you assist students with industrial attachment?",
        answer:
          "Yes. Through the Office of Career Services, students receive support in securing attachment and internship opportunities."
      }
    ]
  }
];
